/* Coil — product image slider. Instance-scoped (no globals); initializes every
 * [data-coil-slider] on the page. ❮ ❯ buttons + keyboard ←/→ + horizontal touch
 * swipe flip between slides with wrap-around. An sr-only aria-live region
 * announces "Image N of M". The CSS owns the cross-fade and its reduced-motion
 * opt-out; this only toggles the `.is-active` class + aria-hidden.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.coilSliderReady === 'true') { return; }
    root.dataset.coilSliderReady = 'true';
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.coil-slider__slide')
    );
    if (slides.length < 2) return;

    var prevBtn = root.querySelector('[data-coil-slider-prev]');
    var nextBtn = root.querySelector('[data-coil-slider-next]');
    var status = root.querySelector('[data-coil-slider-status]');
    if (!prevBtn || !nextBtn) return;

    var index = 0;
    var initialized = false;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      // Skip the announcement for the initial paint; only announce real moves.
      if (status && initialized) {
        status.textContent = 'Image ' + (index + 1) + ' of ' + slides.length;
      }
    }

    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) { return; }
      var t = e.target;
      if (t && t.matches && t.matches('input, textarea, select, [contenteditable]')) { return; }
      if (e.key === 'ArrowLeft') { show(index - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { show(index + 1); e.preventDefault(); }
    });

    var startX = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) { return; }
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { show(dx < 0 ? index + 1 : index - 1); }
      startX = null;
    }, { passive: true });

    show(0);
    initialized = true;
    root.classList.add('is-ready');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-coil-slider]').forEach(init);
  }

  initAll(document);

  // Shopify theme editor: re-init when a section is added/reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
